import React from 'react';
import { Card, Typography } from 'antd';
import RegisterForm from './RegisterForm';
import './RegisterPage.scss';
import { useLocation } from 'react-router-dom';
import authStore from '../../stores/auth.store';

const { Title } = Typography;

const RegisterPage = () => {
  const query = new URLSearchParams(useLocation().search);
  const actionToken = query.get('action_token') || '';
  authStore.setState({
    authToken: actionToken,
  });

  return (
    <div className={'RegisterPage'}>
      <Card title="" className={'RegisterPage__CardLogin'}>
        <div className={'RegisterPage__CardLogin__div'}>
          <Title level={1} className={'RegisterPage__CardLogin__title'}>
            Bienvenido a
          </Title>
          <img
            src={'/assets/images/logo_teinnova.png'}
            alt={'Logo Teinnova'}
          />
        </div>
        <RegisterForm />
      </Card>
    </div>
  );
};

export default RegisterPage;
